export default {
  blank: () => import("/vercel/path0/apps/web/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/apps/web/layouts/default.vue").then(m => m.default || m)
}